import axios from "axios";

// Get the current hostname 
const hostname = window.location.hostname;

// Backend port
const PORT = 8000;

// Dynamic URL
const dynamicBaseURL = hostname === "localhost" || hostname.includes("192.168.")
  ? `http://${hostname}:${PORT}`
  : process.env.REACT_APP_BACKEND_URL; // Fallback production domain

export const API = axios.create({
  baseURL: dynamicBaseURL,
  // Send the httpOnly session cookie set by the backend OIDC callback.
  withCredentials: true,
});
